import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import AgGridComponent from '../../../sharedcomponents/ag-grid/AgGrid';
import {
  Endpoints,
  GenericError,
  UserId,
  Verbiage,
  maxPageSize,
  ProductDeliveryPlatforms,
} from './../../../constants';
import smartHttp from '../../../helpers/smartHttp';
import { Notify } from './../../../sharedcomponents/Alert/Notify';
import ModalBox from './../../../sharedcomponents/modal-box/ModalBox';
import store from '../../../redux/store';
import './clone-user-entitlements.scss';
import { debounce } from '../../../helpers/debounce';
import DistributorsDropdown from './../../Entitlements/DistributorsDropdown';

const CloneUserEntitlements = ({
  showCloneUserEntitlements,
  handleCloseCloneUserEntitlements,
  handleCloneUserEntitlementsSuccess,
  selectedToUsers,
  cloneEntitlementData,
  setCloneEntitlementData,
  allContracts,
  isBPMReferral,
}) => {
  const [rowData, setRowData] = useState();
  const [currentlySelectedSourceUsers, setCurrentlySelectedSourceUsers] =
    useState([]);
  const [sourceUserChanged, setSourceUserChanged] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userIdsChanged, setUserIdsChanged] = useState(false);
  const [initialExUsers, setInitialExUsers] = useState([]);
  const gridApi = useRef(null);
  const gridRef = useRef(null);
  const toUsersRequestRef = useRef(0);
  const cloneSearchInputRef = useRef(null);
  const [isManageUseTab, setIsManageUseTab] = useState(false);
  const [userRowData, setUserRowData] = useState([]);
  const [userInitialRowData, setUserInitialRowData] = useState([]);
  const [errordetails, setErrordetails] = useState('');
  const sourceUsersGridStyle = { height: '45vh' };
  const sourceManageUserIdGridStyle = { height: '55vh' };
  const [forceUpdate, setForceUpdate] = useState(0);
  const [isTradeEntityHide, setIsTradeEntityHide] = useState(true);
  const [filteredDistributors, setFilteredDistributors] = useState();
  const [selectedCloneDistributors, setSelectedCloneDistributors] =
    useState('');
  const [productDeliveryPlatformsIds, setProductDeliveryPlatformsIds] =
    useState([]);
  const [selectedContractType, setSelectedContractType] = useState('');
  const [subscriptionTypeOptions, setSubscriptionTypeOptions] = useState([]);
  const hasContractTypeData =
    (cloneEntitlementData?.contractTypeData?.length || 0) > 0;
  // FEATURE DISABLED (Release july-2026) - Exhibit persona / BPM Referral cloning
  // const statusFilterClause = isBPMReferral
  //   ? '"Draft"'
  //   : '"Active","Pending Active"';
  const statusFilterClause = '"Active","Pending Active"'; // FEATURE DISABLED (Release july-2026)
  const REQUEST_IDS = {
    onSelectionChanged: 'clone-user-entitlements:onSelectionChanged',
    getRequiredEntitlementMappings:
      'clone-user-entitlements:getRequiredEntitlementMappings',
    getSelectedUserIds: 'clone-user-entitlements:getSelectedUserIds',
    getToUsers: 'clone-user-entitlements:getToUsers',
  };

  const DistributorUserIDRequiredList = store
    .getState()
    ?.dbConfig.ManageUserIdDistributors?.filter(
      (item) => item.isRequired === 1,
    );

  const DistributorTradingEntityList = store
    .getState()
    ?.dbConfig.ManageUserIdDistributors?.filter(
      (item) => item.tradingEntity === 1,
    );

  const defaultConfig = {
    rowModelType: 'clientSide',
    isExportCSV: false,
    isExportExcel: false,
    pivotPanelShow: '',
    pagination: false,
    isAutoSizeColumns: true,
    enableCharts: false,
    rowGroupPanelShow: false,
    sideBar: false,
    rowSelection: 'single',
    suppressRowClickSelection: false,
    suppressMultiRangeSelection: true,
    overlayNoRowsTemplate: Verbiage.noData,
  };

  const defaultColdef = {
    filter: false,
    sortable: false,
    enableRowGroup: false,
    enablePivot: false,
    enableValue: false,
    resizable: false,
    headerCheckboxSelection: false,
    checkboxSelection: false,
  };

  const UserIdDefaultColdef = {
    sortable: true,
    resizable: true,
    menuTabs: ['generalMenuTab', 'filterMenuTab'],
  };
  const onManageUserGridReadyHandler = (params) => {
    gridRef.current = params;
    setForceUpdate((prev) => prev + 1);
  };
  const callBackDistributors = (props) => {
    setSelectedCloneDistributors(props);
  };
  const onInputsChanged = (el, prop, params) => {
    let index = userRowData.findIndex(
      (x) =>
        x.distributorId === params.data?.distributorId &&
        x.contactId === params.data?.contactId,
    );
    if (index >= 0) {
      userRowData[index][prop] = el.target?.value;
    }

    // Check if all mandatory fields are now filled
    if (errordetails) {
      const allValid = userRowData.every((du) => {
        // Check required user id
        if (
          DistributorUserIDRequiredList.some(
            (e) => e.distributorId === du.distributorId,
          )
        ) {
          if (!du?.userId?.trim()) return false;
        }
        // Check required trading entity
        if (
          DistributorTradingEntityList.some(
            (e) => e.distributorId === du.distributorId,
          )
        ) {
          if (!du?.contact_Xref_Number?.trim()) return false;
        }
        return true;
      });

      // Only clear error if all mandatory fields are filled
      if (allValid) {
        setErrordetails('');
      }
    }

    setUserRowData([...userRowData]);
  };
  const objectsEqual = (o1, o2) =>
    Object.keys(o1).length === Object.keys(o2).length &&
    Object.keys(o1).every((p) => o1[p] === o2[p]);

  const onInputsChangedDebounce = (el, prop, params) => {
    debounce(onInputsChanged(el, prop, params), 1000);
  };
  const manageUserIdColumns = [
    {
      headerName: '',
      field: 'contactId',
      suppressHeaderMenuButton: true,
      sortable: false,
      hide: true,
    },
    {
      headerName: 'Email ID',
      headerTooltip: 'Email ID',
      field: 'emailId',
      tooltipField: 'emailId',
      initialFlex: 3,
    },
    {
      headerName: 'User Id',
      headerTooltip: 'User Id',
      field: 'userId',
      tooltipField: 'userId',
      initialFlex: 4,
      singleClickEdit: true,
      editable: true,
      cellRenderer: (params) => {
        return (
          <div className="aggrid-input-border">
            {params.data?.userId ? params.data.userId : ''}
          </div>
        );
      },
      menuTabs: ['generalMenuTab'],
      cellClass: (params) => {
        const isRequired = DistributorUserIDRequiredList.some(
          (e) => e.distributorId === params.data?.distributorId,
        );
        const isEmpty = !params.data?.userId || !params.data.userId.trim();
        const showError = isRequired && isEmpty && errordetails;
        return showError
          ? 'aggrid-input-wrapper cell-error-highlight'
          : 'aggrid-input-wrapper';
      },
    },
    {
      headerName: 'Trading Entity Name',
      headerTooltip: 'Trading Entity Name',
      field: 'contact_Xref_Number',
      tooltipField: 'contact_Xref_Number',
      initialFlex: 4,
      hide: isTradeEntityHide,
      singleClickEdit: true,
      editable: (params) => {
        return (
          params?.data &&
          DistributorTradingEntityList?.some(
            (x) => x.distributorId === params.data.distributorId,
          )
        );
      },
      cellRenderer: (params) => {
        if (isTradeEntityHide) return null;
        const isTradingEntity =
          params?.data &&
          DistributorTradingEntityList?.some(
            (x) => x.distributorId === params.data.distributorId,
          );
        return (
          <div
            className={`aggrid-input-border ${
              !isTradingEntity ? 'aggrid-disabled-cell' : ''
            }`}
          >
            {isTradingEntity ? params.data.contact_Xref_Number : 'N/A'}
          </div>
        );
      },
      menuTabs: ['generalMenuTab'],
      cellClass: (params) => {
        const isTradingEntity =
          params?.data &&
          DistributorTradingEntityList?.some(
            (x) => x.distributorId === params.data.distributorId,
          );
        const isEmpty =
          !params.data?.contact_Xref_Number ||
          !params.data.contact_Xref_Number.trim();
        const showError = isTradingEntity && isEmpty && errordetails;
        return showError
          ? 'aggrid-input-wrapper cell-error-highlight'
          : 'aggrid-input-wrapper';
      },
    },
    {
      headerName: 'Distributor Platform',
      headerTooltip: 'Distributor Platform',
      field: 'distributorPlatform',
      tooltipField: 'distributorPlatform',
      initialFlex: 3,
    },
    {
      headerName: 'Distributor',
      headerTooltip: 'Distributor',
      field: 'distributor',
      tooltipField: 'distributor',
      initialFlex: 3,
      cellRenderer: (params) => {
        if (
          params?.data &&
          (DistributorUserIDRequiredList.some(
            (e) => e.distributorId === params.data.distributorId,
          ) ||
            DistributorTradingEntityList.some(
              (e) => e.distributorId === params.data.distributorId,
            ))
        ) {
          return (
            <div style={{ position: 'relative' }}>
              <span
                className="asterik"
                style={{
                  position: 'absolute',
                  left: '-12px',
                }}
              >
                *
              </span>
              <span>{params.value}</span>
            </div>
          );
        } else return params.value;
      },
    },
    {
      headerName: 'User ID Format',
      headerTooltip: 'User ID Format',
      field: 'userIdFormat',
      tooltipField: 'userIdFormat',
      initialFlex: 3,
    },
  ];
  const onCloneUserEntitlementsClose = async () => {
    handleCloseCloneUserEntitlements();
  };

  const toQuotedCsv = (values) =>
    (values || [])
      .filter(Boolean)
      .map((value) => `"${value}"`)
      .join(',');

  const onSelectionChanged = () => {
    const selectedUsers = gridApi.current.api
      .getSelectedNodes()
      .map((node) => node.data);

    setCurrentlySelectedSourceUsers(selectedUsers);

    if (!selectedUsers.length) return;

    try {
      const contactId = selectedUsers[0].contactId;
      const contractNumbers = getContractNumbersForType();

      if (!contractNumbers?.length) {
        setFilteredDistributors(undefined);
        return;
      }

      const contractNumberFilter = contractNumbers
        ? toQuotedCsv(contractNumbers)
        : '';

      const hcAccountId = allContracts?.find((c) => c.checked)?.hC_AccountID;
      const mappingQueryParams = hcAccountId
        ? {
            pageSize: 5000,
            filter: `hcaccountid:"${hcAccountId}" AND isdeleted:0`,
          }
        : null;

      Promise.all([
        smartHttp.get(
          Endpoints.userentitlementsApi,
          {
            pageSize: maxPageSize,
            id: Date.now(),
            Field:
              'distributor,distributorId,distributorPlatform,distributorDisplayName,distributorPlatformDisplayName,deliveryType,platformCategories',
            filter: `contractNumber IN(${contractNumberFilter}) AND contactId IN("${contactId}") AND status IN(${statusFilterClause})`,
          },
          { requestId: REQUEST_IDS.onSelectionChanged },
        ),
        mappingQueryParams
          ? smartHttp.getRapid(
              Endpoints.companyDistributorMappingApi,
              mappingQueryParams,
            )
          : Promise.resolve(null),
      ]).then(([entitlementRes, mappingRes]) => {
        const mappedIds = (mappingRes?.data?.results || [])
          .map((m) => m.distributorId ?? m.distributorid)
          .filter((id) => id !== undefined && id !== null);
        const mappedIdSet = new Set(mappedIds);
        const filteredDistributorsData = (
          entitlementRes?.data?.results || []
        ).filter(
          (item) =>
            mappedIdSet.size === 0 || mappedIdSet.has(item.distributorId),
        );
        const matchingDistributors = filteredDistributorsData.filter((item) =>
          ProductDeliveryPlatforms.includes(item.distributor),
        );

        const matchingDistributorIds = matchingDistributors.map(
          (item) => item.distributorId,
        );

        setProductDeliveryPlatformsIds(matchingDistributorIds);

        // Set the final result
        setFilteredDistributors({
          results: filteredDistributorsData,
        });
      });
    } catch (error) {
      console.error('Error fetching entitlement/package data:', error);
    }
  };

  useEffect(() => {
    cloneSearchInputRef.current?.focus();
  }, []);

  useEffect(() => {
    if (currentlySelectedSourceUsers?.length > 0) {
      setSourceUserChanged(true);
    } else {
      setSourceUserChanged(false);
    }
  }, [currentlySelectedSourceUsers]);

  useEffect(() => {
    if (gridRef.current && gridRef.current.api && userRowData.length > 0) {
      const shouldHide = userRowData.every(
        (row) =>
          !DistributorTradingEntityList.some(
            (x) => x.distributorId === row.distributorId,
          ),
        gridRef,
      );
      setIsTradeEntityHide(shouldHide);
      // Hide or show the column
    }
  }, [userRowData, forceUpdate]);
  const onSourceUserGridReadyHandler = (params) => {
    gridApi.current = params;
    params.api.sizeColumnsToFit('contactName', false);
    params.api.setGridOption('headerHeight', 0);
  };

  const contactNameEmailGetter = (params) => {
    if (params.data)
      return params.data.contactName + ' (' + params.data.email + ')';

    return '';
  };

  const sourceUsersColumns = [
    {
      headerName: '',
      field: 'contactName',
      suppressHeaderMenuButton: true,
      sortable: false,
      valueGetter: contactNameEmailGetter,
      tooltipValueGetter: contactNameEmailGetter,
    },
  ];

  const getToContract = (data) => {
    const virtual = data.find((d) => d.isVirtualContract === 1);
    if (virtual) return '"' + virtual.contractNumber + '"';

    const nonVirtual = data.find((d) => !d.isVirtualContract);
    return '"' + nonVirtual?.contractNumber + '"' || '';
  };

  const getToUsers = async (dataFromAddUser, contractType) => {
    const requestId = ++toUsersRequestRef.current;
    gridApi?.current?.api?.showLoadingOverlay();
    const contractNums = getContractNumbersForType(contractType);

    if (!contractNums?.length) {
      if (requestId !== toUsersRequestRef.current) return;
      setRowData([]);
      gridApi?.current?.api?.showNoRowsOverlay();
      return;
    }

    const contractNumber = toQuotedCsv(contractNums);
    const contractTypeFilter = contractType
      ? ` AND contractType:"${contractType}"`
      : '';

    try {
      let queryParams = {
        PageSize: 50000,
        Field: 'contactName,contactId,email',
        Filter: `contractNumber IN(${contractNumber})${contractTypeFilter} AND entitled:"Yes"`,
      };

      let emailToExclude = selectedToUsers?.map((el) => el?.email);

      const sourceUsersResponse = await smartHttp.get(
        Endpoints.userApi,
        queryParams,
        { requestId: `${REQUEST_IDS.getToUsers}:${requestId}` },
      );
      // Request was cancelled (smartFetch returns null) — let the newer request handle the grid
      if (!sourceUsersResponse) return;
      // Exclude clone to emails
      let filteredData = sourceUsersResponse?.data?.results?.filter(
        ({ email }) => !emailToExclude?.includes(email),
      );
      if (requestId !== toUsersRequestRef.current) return;

      setRowData(filteredData || []);
      if ((filteredData || []).length > 0) {
        gridApi?.current?.api?.hideOverlay();
      } else {
        gridApi?.current?.api?.showNoRowsOverlay();
      }
    } catch (err) {
      if (requestId !== toUsersRequestRef.current) return;
      if (err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError') {
        return;
      }
      gridApi?.current?.api?.showNoRowsOverlay();
      Notify({
        alert: true,
        type: 'error',
        title: GenericError.somethingWentWrong,
      });
    }
  };
  useEffect(() => {
    let initContractType = '';
    if (hasContractTypeData) {
      const types = cloneEntitlementData.contractTypeData.map(
        (x) => x.contractType,
      );
      setSubscriptionTypeOptions(types);
      initContractType = types[0] || '';
      setSelectedContractType(initContractType);
    } else if (selectedToUsers?.length > 0) {
      initContractType = selectedToUsers[0]?.contractType || '';
      setSelectedContractType(initContractType);
      setSubscriptionTypeOptions(initContractType ? [initContractType] : []);
    } else {
      setSubscriptionTypeOptions([]);
      setSelectedContractType('');
    }
    if (selectedToUsers?.length > 0 || hasContractTypeData) {
      getToUsers(cloneEntitlementData, initContractType);
    }
  }, [selectedToUsers, cloneEntitlementData, hasContractTypeData]);

  const onFilterTextBoxChanged = () => {
    if (rowData) {
      gridApi.current.api.setGridOption(
        'quickFilterText',
        document.getElementById('search-filter-input').value.trim(),
      );
      if (gridApi.current.api.getDisplayedRowCount() <= 0) {
        gridApi?.current?.api?.showNoRowsOverlay();
      } else {
        gridApi?.current?.api.hideOverlay();
      }
    }
  };

  useEffect(() => {
    let initialRowData = !userInitialRowData ? [] : userInitialRowData;
    let modifiedRowData = !userRowData ? [] : userRowData;
    if (objectsEqual(modifiedRowData, initialRowData)) {
      setUserIdsChanged(false);
    } else {
      setUserIdsChanged(true);
    }
  }, [userRowData]);

  const getContractNumberDetails = () => {
    let contractNumber = allContracts?.find(
      (c) =>
        c.contractNumber === currentlySelectedSourceUsers[0]?.contractNumber,
    );
    if (contractNumber && contractNumber.isVirtualContract) {
      return contractNumber?.mappedContractNumber?.split(',');
    } else {
      return [currentlySelectedSourceUsers[0]?.contractNumber];
    }
  };

  // Parses a comma-separated contract number string into a unique, trimmed array.
  const parseContractNumbers = (csvStr) => [
    ...new Set(
      (csvStr || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean),
    ),
  ];

  // Returns the array of contract numbers for the given (or currently selected) contractType.
  // For User Grid: parses allContractNumber from selectedToUsers[0].
  // For AddUser: uses the contracts[] from contractTypeData for the selected type.
  const getContractNumbersForType = (contractTypeOverride) => {
    const contractTypeData = cloneEntitlementData?.contractTypeData || [];
    if (contractTypeData.length > 0) {
      const activeType =
        contractTypeOverride ??
        selectedContractType ??
        contractTypeData[0]?.contractType;

      const matchedTypeData = contractTypeData.find(
        (x) => x.contractType === activeType,
      );
      const fallbackTypeData = matchedTypeData || contractTypeData[0];

      return fallbackTypeData?.contracts || [];
    }

    if (selectedToUsers?.length > 0) {
      return parseContractNumbers(selectedToUsers[0]?.allContractNumber);
    }

    return [];
  };

  const handleContractTypeChange = (e) => {
    const newType = e.target.value;
    if (subscriptionTypeOptions.length <= 1 || newType === selectedContractType)
      return;
    setSelectedContractType(newType);
    setCurrentlySelectedSourceUsers([]);
    setSourceUserChanged(false);
    setFilteredDistributors(undefined);
    getToUsers(cloneEntitlementData, newType);
  };
  const getRequiredEntitlementMappings = async () => {
    try {
      let requiredDistributorIds = [
        ...new Set([
          ...DistributorUserIDRequiredList,
          ...DistributorTradingEntityList,
        ]),
      ];

      let filteredDistributorIds =
        selectedCloneDistributors?.length > 0
          ? selectedCloneDistributors.filter((x) =>
              requiredDistributorIds.some(
                (dt) => dt.distributorId === x.distributorId,
              ),
            )
          : requiredDistributorIds;
      if (
        currentlySelectedSourceUsers?.length > 0 &&
        filteredDistributorIds?.length > 0
      ) {
        let queryParams = {
          field:
            'distributorId,distributor,distributorPlatform,distributorDisplayName,distributorPlatformDisplayName,userIdFormat',
          pageSize: 5000,
          Filter: `contractNumber IN(${toQuotedCsv(getContractNumbersForType())}) AND contactid IN(${currentlySelectedSourceUsers
            .map((x) => '"' + x.contactId + '"')
            .join(',')}) AND distributorId IN(${filteredDistributorIds
            .map((d) => d.distributorId)
            .join(',')}) AND status IN(${statusFilterClause})`,
        };
        const requiredMappings = await smartHttp.get(
          Endpoints.userentitlementsApi,
          queryParams,
          { requestId: REQUEST_IDS.getRequiredEntitlementMappings },
        );
        return requiredMappings?.data?.results;
      } else {
        return [];
      }
    } catch (error) {
      throw error;
    }
  };

  const getSelectedUserIds = async () => {
    try {
      if (selectedToUsers?.length > 0) {
        let queryParams = {
          field:
            'distributorId,distributor,distributorPlatform,distributorDisplayName,distributorPlatformDisplayName,userId,contactId,contact_Xref_Number',
          pageSize: 5000,
          Filter: `contactid IN(${selectedToUsers
            .map((x) => '"' + x.contactId + '"')
            .join(',')}) AND distributorId IN(${[
            ...new Set([
              ...DistributorUserIDRequiredList,
              ...DistributorTradingEntityList,
            ]),
          ]
            .map((d) => d.distributorId)
            .join(',')})`,
        };
        const requiredMappings = await smartHttp.get(
          Endpoints.distributorUserApi,
          queryParams,
          { requestId: REQUEST_IDS.getSelectedUserIds },
        );
        setInitialExUsers(requiredMappings?.data?.results);
        return requiredMappings?.data?.results;
      } else {
        return [];
      }
    } catch (error) {
      throw error;
    }
  };

  const validateUserIdForEntitlement = async () => {
    try {
      if (
        currentlySelectedSourceUsers &&
        currentlySelectedSourceUsers.length > 0
      ) {
        setLoading(true);
        const sourceUsersResponse = await getRequiredEntitlementMappings();
        if (sourceUsersResponse) {
          if (sourceUsersResponse.length > 0) {
            const existingUserIds = await getSelectedUserIds();
            if (existingUserIds) {
              // setIsManageUseTab(true);
              let gridData = getManageUserIdRequiredRows(
                selectedToUsers,
                sourceUsersResponse,
                existingUserIds,
              );
              if (gridData.length > 0) {
                setIsManageUseTab(true);
                let initialData = gridData?.map((data) => ({
                  ...data,
                }));
                setUserInitialRowData(initialData);
                setUserRowData(gridData);
                gridRef?.current?.api?.hideOverlay();
              } else {
                gridRef?.current?.api?.showNoRowsOverlay();
                cloneEntitlements();
              }
            }
          } else {
            gridRef?.current?.api?.showNoRowsOverlay();
            cloneEntitlements();
          }
        }
      }
    } catch (error) {
      Notify({
        alert: true,
        type: 'error',
        title: GenericError.somethingWentWrong,
      });
    } finally {
      setLoading(false);
    }
  };

  const cloneEntitlements = () => {
    try {
      if (
        currentlySelectedSourceUsers &&
        currentlySelectedSourceUsers.length > 0
      ) {
        let sourceUsers = currentlySelectedSourceUsers
          .map((t) => t.contactId)
          .join(',');
        let destinationUsers =
          cloneEntitlementData?.contactId ??
          selectedToUsers
            .map((t) => t.contactId)
            .filter(
              (value, index, current_value) =>
                current_value.indexOf(value) === index,
            )
            .join(',');
        let distributorIds = '';
        if (selectedCloneDistributors.length > 0) {
          let distributorIdSet = new Set(
            selectedCloneDistributors.map((d) => d.distributorId),
          );

          // Convert to comma-separated string
          distributorIds = Array.from(distributorIdSet).join(',');
        }

        let params = {
          fromUsers: sourceUsers,
          toUsers: destinationUsers,
          distributorIds: distributorIds,
          contractType: selectedContractType,
        };
        setLoading(true);
        smartHttp
          .post(Endpoints.userEntitlementsCloneApi, null, params)
          .then(() => {
            handleCloneUserEntitlementsSuccess();
            onCloneUserEntitlementsClose();
            Notify({
              alert: true,
              type: 'success',
              title: 'User entitlements cloned successfully',
            });
            setLoading(false);
          })
          .catch((err) => {
            // FEATURE DISABLED (Release july-2026) - LME Governance Check (Story 9862470)
            // let errorMsg =
            //   err?.response?.data.code === -3
            //     ? Verbiage.lmeEntitlementsGovernanceFailed
            //     : GenericError.somethingWentWrong;
            let errorMsg = GenericError.somethingWentWrong;
            Notify({
              alert: true,
              type: 'error',
              title: errorMsg,
            });
          })
          .finally(() => setLoading(false));
      }
    } catch (err) {}
  };
  const getChangedDistributorUsers = () => {
    let updatedDistributorUsers = [];
    userRowData.map((du) => {
      let existingDistributorUsers = initialExUsers.filter(
        (x) => x.distributorId === du.distributorId,
      );
      if (existingDistributorUsers?.length > 0) {
        if (
          du.userId !== existingDistributorUsers[0].userId ||
          du.contact_Xref_Number !==
            existingDistributorUsers[0].contact_Xref_Number
        )
          updatedDistributorUsers.push(du);
      } else {
        if (du.userId || du.contact_Xref_Number)
          updatedDistributorUsers.push(du);
      }
    });
    return updatedDistributorUsers;
  };

  const saveDistributorUserIds = async () => {
    try {
      if (
        userRowData.filter(
          (u) =>
            (DistributorUserIDRequiredList.some(
              (e) => e.distributorId === u.distributorId,
            ) &&
              !u.userId?.trim()) ||
            (DistributorTradingEntityList.some(
              (e) => e.distributorId === u.distributorId,
            ) &&
              !u.contact_Xref_Number?.trim()),
        ).length === 0
      ) {
        const changedUserIds = getChangedDistributorUsers();
        setErrordetails('');
        setLoading(true);
        if (changedUserIds?.length > 0) {
          let postUserDistributor = {
            distributorUsers: changedUserIds.map((ur) => {
              return {
                userId: ur.userId,
                contactId: ur.contactId,
                distributorId: ur.distributorId,
                contact_xref_number: ur.contact_Xref_Number,
              };
            }),
            userId: UserId,
          };
          let postDistributorUserResponse = await smartHttp.post(
            Endpoints.distributorUserApi,
            postUserDistributor,
          );
          if (postDistributorUserResponse) cloneEntitlements();
        } else {
          cloneEntitlements();
        }
      } else {
        setErrordetails(
          'Please ensure all fields indicated as mandatory are specified',
        );
      }
    } catch (err) {
      setLoading(false);
      Notify({
        alert: true,
        type: 'error',
        title: GenericError.somethingWentWrong,
      });
    }
  };

  /**
   * Returns rows that require Manage User ID tab to be shown.
   * If distributor is in DistributorUserIDRequiredList, checks userId.
   * If distributor is in DistributorTradingEntityList, checks both userId and contact_Xref_Number.
   * @param {Array} userRowData - Array of user rows to validate.
   * @returns {Array} - Rows needing update in Manage User ID grid.
   */
  const getManageUserIdRequiredRows = (
    selectedToUsers,
    sourceUsersResponse,
    existingUserIds,
  ) => {
    if (!Array.isArray(selectedToUsers) || !Array.isArray(sourceUsersResponse))
      return [];
    let gridData = [];
    selectedToUsers.forEach((user) => {
      sourceUsersResponse.forEach((resp) => {
        let existingIdIndex = -1;
        if (Array.isArray(existingUserIds) && existingUserIds.length > 0) {
          existingIdIndex = existingUserIds.findIndex(
            (uid) =>
              uid.distributorId === resp.distributorId &&
              uid.contactId === user.contactId,
          );
        }
        const userId =
          existingIdIndex === -1 ? '' : existingUserIds[existingIdIndex].userId;
        const contact_Xref_Number =
          existingIdIndex === -1
            ? ''
            : existingUserIds[existingIdIndex].contact_Xref_Number;
        const row = {
          userId: userId,
          userIdFormat: resp.userIdFormat,
          distributorId: resp.distributorId,
          distributor: resp.distributor,
          distributorPlatform: resp.distributorPlatform,
          contactId: user.contactId,
          emailId: user.email,
          contact_Xref_Number: contact_Xref_Number,
        };
        // Validation logic
        const isUserIdRequired = DistributorUserIDRequiredList.some(
          (d) => d.distributorId === row.distributorId,
        );
        const isTradingEntityRequired = DistributorTradingEntityList.some(
          (d) => d.distributorId === row.distributorId,
        );
        if (
          (isUserIdRequired && (!row.userId || !row.userId.trim())) ||
          (isTradingEntityRequired &&
            (!row.userId ||
              !row.userId.trim() ||
              !row.contact_Xref_Number ||
              !row.contact_Xref_Number.trim()))
        ) {
          gridData.push(row);
        }
      });
    });
    return gridData;
  };

  return (
    <>
      <ModalBox
        backdrop="static"
        size="lg"
        show={showCloneUserEntitlements}
        handleClose={onCloneUserEntitlementsClose}
        showLoader={loading}
        modalTitle={
          isManageUseTab ? (
            <>Clone - Manage User IDs</>
          ) : (
            <>
              Clone Users
              <span className="clone-user-entitlements-subtitle">
                (Select user to clone from)
              </span>
            </>
          )
        }
      >
        <div className="container">
          {isManageUseTab ? (
            <>
              <div className="row">
                <div className="col no-scroll">
                  <AgGridComponent
                    config={defaultConfig}
                    gridStyle={sourceManageUserIdGridStyle}
                    defaultColumnDef={UserIdDefaultColdef}
                    columns={manageUserIdColumns}
                    data={userRowData}
                    onGridReady={onManageUserGridReadyHandler}
                  />
                </div>
              </div>

              <Row className="modal-row">
                <div className="col-8">
                  <span className="d-block email-preference-note-label">
                    <span className="text-danger">*</span> Mandatory
                  </span>
                  <span className="text-danger">{errordetails}</span>
                </div>
                <div className="col-4">
                  <Form>
                    <Form.Group className="entitlements-clone-btn-body">
                      <button
                        type="button"
                        disabled={!userIdsChanged}
                        className="btn btn-dark float-end btn-opacity"
                        onClick={saveDistributorUserIds}
                      >
                        Save
                      </button>
                    </Form.Group>
                  </Form>
                </div>
              </Row>
            </>
          ) : (
            <div>
              <div className="row mt-2">
                <div
                  className={
                    subscriptionTypeOptions.length > 0 ? 'col-md-8' : 'col'
                  }
                >
                  <input
                    type="text"
                    id="search-filter-input"
                    className="form-control search-box"
                    placeholder="Search by name, email address"
                    onInput={onFilterTextBoxChanged}
                    autoFocus
                    ref={cloneSearchInputRef}
                  ></input>
                </div>
                {subscriptionTypeOptions.length > 0 && (
                  <div className="col-md-4">
                    <Form.Select
                      value={selectedContractType}
                      onChange={handleContractTypeChange}
                      disabled={subscriptionTypeOptions.length <= 1}
                      className="search-box"
                      aria-label="Subscription Type"
                    >
                      {subscriptionTypeOptions.map((type) => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col no-scroll">
                  <AgGridComponent
                    config={defaultConfig}
                    gridStyle={sourceUsersGridStyle}
                    defaultColumnDef={defaultColdef}
                    data={rowData}
                    suppressRowClickSelection={false}
                    columns={sourceUsersColumns}
                    onSelectionChanged={onSelectionChanged}
                    onGridReady={onSourceUserGridReadyHandler}
                  />
                </div>
              </div>

              <Row className="modal-row">
                <Form className="w-100">
                  <Row className="w-100 g-0 align-items-end">
                    {sourceUserChanged && (
                      <Col md={6}>
                        <Form.Group
                          controlId="distributorsDropdown"
                          className="clone-dist-dropdown"
                        >
                          <DistributorsDropdown
                            DataSet={filteredDistributors}
                            callBackDistributors={callBackDistributors}
                            Type="CloneUserEntitlements"
                          />
                        </Form.Group>
                      </Col>
                    )}

                    <Col
                      md={!sourceUserChanged ? 12 : 6}
                      className="d-flex justify-content-end align-items-end"
                    >
                      <Form.Group className="entitlements-clone-btn-body">
                        <button
                          type="button"
                          disabled={!sourceUserChanged}
                          onClick={validateUserIdForEntitlement}
                          className="btn btn-dark btn-opacity"
                        >
                          Save Entitlements
                        </button>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </Row>
            </div>
          )}
        </div>
      </ModalBox>
    </>
  );
};

export default memo(CloneUserEntitlements);
